<!-- Spinner -->
<div *ngIf="isLoadingg" class="spinner-center-wrapper">
  <div class="spinner-center"></div>
  Redirecting ....
</div>

<app-alert></app-alert>
<router-outlet></router-outlet>
